export default interface ICPTModifier {
    Id: string;
    Code: string;
    Description: string;
    ApplicablePOSValues: number[];
    IsActive: boolean;
}

export class CPTModifier implements ICPTModifier {
    Id: string;
    Code: string;
    Description: string;
    ApplicablePOSValues: number[];
    IsActive: boolean;

    constructor() {
        this.Id = '';
        this.Code = '';
        this.Description = '';
        this.ApplicablePOSValues = [];
        this.IsActive = true;
    }
}
